export { default } from './SpecialPagesView';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/SpecPages/SpecialPagesView/index.js